module.exports = __webpack_public_path__ + "static/22-a262fcf6cdb6a2001a167a078f99da02.jpg";